import Link from '@tiptap/extension-link'
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { getAttributes } from "@tiptap/core";

export const MAMLink = Link.extend({
  addStorage(this: any) {
    return {
      ...(this.parent?.() ?? {}),
      __isImperiaLink: true,
    }
  },
  addAttributes(this: any) {
    // Return an object with attribute configuration
    return {
      ...(this.parent?.() ?? {}),
      class: {
        default: null
      },
      id: {
        default: null
      },
      hreflang: {
        default: null
      },
      title: {
        default: null
      },
      style: {
        default: null
      },
      name: {
        default: null
      },
      longdesc: {
        default: null
      },
      'data-node-id': {
        default: null
      }
    }
  },
  addInputRules() {
    return []
  },
  addOptions(this: any) {
    return {
      ...this.parent?.(),
      defaultProtocol: '',
    };
  },
  addProseMirrorPlugins(this: any) {
    const plugins: Plugin[] = this.parent?.() || [];

    const ctrlClickHandler = new Plugin({
      key: new PluginKey("handleControlClick"),
      props: {
        handleClick(view, pos, event) {
          const attrs = getAttributes(view.state, "link");
          const link = (event.target as HTMLElement)?.closest("a");

          const keyPressed = event.ctrlKey || event.metaKey;

          if (keyPressed && link && attrs.href) {
            window.open(attrs.href, '_blank');

            return true;
          }

          return false;
        }
      }
    });

    plugins.push(ctrlClickHandler);

    return plugins;
  }
})